import { createSlice, isPending, isRejected } from '@reduxjs/toolkit';
import { RootState } from '../..';
import getSubjects from './api';

export interface IGrade {
  _id?: string;
  grade: string;
}

export interface ICurriculum {
  curriculum: string;
  grades: Array<IGrade>;
}

export interface ISubject {
  subject: string;
  curriculums: Array<ICurriculum>;
}

export interface ICurriculumV2State {
  status: 'idle' | 'loading' | 'rejected';
  list: ISubject[];
}

const initialState: ICurriculumV2State = {
  status: 'idle',
  list: [],
};

export const SubjectSlice = createSlice({
  name: 'subject',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getSubjects.fulfilled, (state, action) => {
      state.status = 'idle';
      state.list = action.payload;
    });
    // Matchers
    builder
      .addMatcher(isPending(getSubjects), (state) => {
        state.status = 'loading';
      })
      .addMatcher(isRejected(getSubjects), (state) => {
        state.status = 'rejected';
      });
  },
});

export const getSubjectState = (state: RootState): RootState['subject'] =>
  state.subject;

export * from './api';
export default SubjectSlice.reducer;
